import { phoneNumberSchema } from "@/utils/zod.ts";
import { z } from "zod";

export const accountManagerAttributesSchema = z.object({
    fullName: z.string(),
    emailAddress: z.string(),
    phoneNumber: phoneNumberSchema,
    photoObjectKey: z.string(),
});
